import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TextField, Button, Container, Typography, Box, Alert, CircularProgress } from '@mui/material';
import useApiService from '../../component/hooks/useApiService';
import onsaLogo from '../../assets/images/onsa-logo.png';

const LoginPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { executePost } = useApiService();

  const handleLogin = async () => {
    setLoading(true);
    setError('');
    try {
      const result = await executePost({
        url: 'auth/admin/login',
        data: { email, password },
        setStateDelegate: () => {},
      });

      sessionStorage.setItem('token', result.access_token);
      sessionStorage.setItem('email', result.admin.email);
      sessionStorage.setItem('refresh_token', result.refresh_token);
      sessionStorage.setItem('role', result.admin.role);

            navigate(
                (result?.admin?.role || '').toLowerCase() === 'super_admin'
                    ? '/admin-list'
                    : '/user-list'
            );
        } catch (err) {
            const message = err?.response?.data?.message || 'Email veya şifre hatalı.';
            setError(message);
        } finally {
            setLoading(false); // 🔹 İşlem bittiğinde loading kapat
        }
    };

  return (
    <Container maxWidth="xs">
      <Box sx={{ mt: 8 }}>
        {/* Logo */}
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
          <img src={onsaLogo} alt="Onsa Logo" style={{ maxWidth: 160 }} />
        </Box>

        <Typography variant="h5" align="center" gutterBottom>
          Admin Giriş
        </Typography>

        {/* 🔹 Tarayıcı autofill’i azaltmak için autoComplete="off" */}
        <form
          autoComplete="off"
          onSubmit={(e) => {
            e.preventDefault();
            if (!loading) handleLogin();
          }}
        >
          {/* 🔹 Chrome’un agresif doldurmasını emmek için opsiyonel “dummy” alanlar */}
          <input type="text" name="fake-username" autoComplete="username" style={{ display: 'none' }} />
          <input type="password" name="fake-password" autoComplete="new-password" style={{ display: 'none' }} />

          <TextField
            fullWidth
            margin="normal"
            label="Email"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="username"
          />

          <TextField
            fullWidth
            margin="normal"
            label="Şifre"
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
          />

          {error && (
            <Box sx={{ mt: 1 }}>
              <Alert severity="error">{error}</Alert>
            </Box>
          )}

          <Button
            fullWidth
            type="submit"
            variant="contained"
            sx={{ mt: 3 }}
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : 'Giriş Yap'}
          </Button>
        </form>
      </Box>
    </Container>
  );
};

export default LoginPage;
